export const getShortName = (username) => {
  let capitalLettre = username.split(' ').map(n => n[0]).join('');
  return capitalLettre;
}